import React from 'react';

import type { UsePopoverReturn } from './usePopover';

type ContextType = UsePopoverReturn | null;

const PopoverContext = React.createContext<ContextType>(null);

export const usePopoverContext = (): NonNullable<ContextType> => {
  const context = React.useContext(PopoverContext);

  if (context == null) {
    throw new Error('Popover components must be wrapped in <Popover />');
  }

  return context;
};

export { PopoverContext };
